import { memo, useState } from "react";

import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";

import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

import { FindingState, FindingStateLabel } from "stores/FindingStore";

import Abstract from "./Abstract";

// -----------------------------------------------------------------------------

const OrganizationFindingStateRow = memo(function OrganizationFindingStateRow({
  state,
}: OrganizationFindingStateRowProps): JSX.Element {
  const [show, setShow] = useState(false);

  return (
    <Abstract label="State">
      <Typography
        variant="body1"
        sx={{ display: "flex", alignItems: "center" }}
      >
        {FindingStateLabel[state] || "Unknown"}{" "}
        <Tooltip
          open={show}
          onOpen={() => setShow(true)}
          onClose={() => setShow(false)}
          enterTouchDelay={0}
          placement="top"
          title={
            <>
              <span>Finding states are:</span>
              <ul style={{ margin: "0 0 0 16px", padding: 0 }}>
                <li>
                  <strong>New</strong> - A new finding
                </li>
                <li>
                  <strong>Notified</strong> - The finding has been seen
                  previously by someone (this site, slack, etc)
                </li>
                <li>
                  <strong>Resolved</strong> - The finding is no longer valid due
                  to changes to the resource or associated policies
                </li>
                <li>
                  <strong>Acknowledged</strong> - The finding{" "}
                  <em>is still active</em>, but has been explicitly acknowledged
                  (but not ignored)
                </li>
                <li>
                  <strong>Ignored</strong> - the finding{" "}
                  <em>is still active</em>, but has been explicitly ignored
                </li>
                <li>
                  <strong>Source Disconnected</strong> - the finding was an
                  active finding, but the source associated with the finding was
                  disconnected
                </li>
              </ul>
            </>
          }
        >
          <HelpOutlineIcon sx={{ height: 18 }} />
        </Tooltip>
      </Typography>
    </Abstract>
  );
});

export default OrganizationFindingStateRow;

// -----------------------------------------------------------------------------

interface OrganizationFindingStateRowProps {
  state: FindingState;
}
